// AWS Amplify configuration for Bonapisca
import { PUBLIC_ACCOUNT_FEATURES_ENABLED } from './publicFeatures';

if (!PUBLIC_ACCOUNT_FEATURES_ENABLED) {
  console.log('Public account auth is disabled for the public site.');
}

// Get environment variables with validation
const getUserPoolId = (): string => {
  const userPoolId = import.meta.env.VITE_USER_POOL_ID;
  if (!userPoolId) {
    console.error('VITE_USER_POOL_ID environment variable is required');
    throw new Error('Missing required environment variable: VITE_USER_POOL_ID');
  }
  return userPoolId;
};

const getUserPoolClientId = (): string => {
  const clientId = import.meta.env.VITE_USER_POOL_CLIENT_ID;
  if (!clientId) {
    console.error('VITE_USER_POOL_CLIENT_ID environment variable is required');
    throw new Error('Missing required environment variable: VITE_USER_POOL_CLIENT_ID');
  }
  return clientId;
};

const getAwsRegion = (): string => {
  return import.meta.env.VITE_AWS_REGION || 'eu-central-1';
};

// Amplify v6 configuration format - using environment variables
const amplifyConfig = PUBLIC_ACCOUNT_FEATURES_ENABLED
  ? {
      Auth: {
        Cognito: {
          userPoolId: getUserPoolId(),
          userPoolClientId: getUserPoolClientId(),
          loginWith: {
            email: true
          }
        }
      }
    }
  : {};

// Configure Amplify
try {
  if (PUBLIC_ACCOUNT_FEATURES_ENABLED) {
    const moduleName = 'aws-amplify';
    void import(/* @vite-ignore */ moduleName).then(({ Amplify }) => {
      Amplify.configure(amplifyConfig);
      console.log('✅ AWS Amplify configured successfully');
    });
  }
} catch (error) {
  console.error('❌ Failed to configure AWS Amplify:', error);
  throw error;
}

// Export for use in components and services
export default amplifyConfig;
